import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ClickOutsideDirective } from '../../../../shared/directives/click-outside/click-outside.directive';
import { CloseButtonComponent } from '../../../../shared/components/close-button/close-button.component';

import { ButtonComponent } from '../../../forms/button/button.component';

@Component({
  selector: 'switch-overlay',
  templateUrl: './switch-overlay.component.html',
  styleUrls: ['./switch-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ClickOutsideDirective, CloseButtonComponent, ButtonComponent],
})
export class SwitchOverlayComponent {
  @Output()
  public confirm: EventEmitter<any> = new EventEmitter();

  @Input()
  public activeTab: any;

  @Input()
  public tabs: any[];

  @Input()
  public title: string;

  @Input()
  public buttonText: string;

  public onConfirm() {
    this.confirm.emit(this.activeTab);
  }

  public onCloseModal() {
    this.confirm.emit(null);
  }

  public setActiveTab(value: any) {
    this.activeTab = value;
  }

  public onClickOutside() {
    this.confirm.emit(null);
  }
}
